/** Plain-text rendering of a CkEditorField HTML value, for table cells, exports, and other non-HTML contexts. */
export const stripHtml = (html: string | null | undefined): string => {
  if (!html) return '';
  const container = document.createElement('div');
  container.innerHTML = html;
  container.querySelectorAll('br').forEach((element) => element.replaceWith(' '));
  container.querySelectorAll('p, div, li, blockquote, h1, h2, h3, h4, h5, h6').forEach((element) => {
    element.append(document.createTextNode(' '));
  });
  return (container.textContent ?? '').replace(/\s+/g, ' ').trim();
};
